import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';


export const SessionInfoTable = withStyles({
	table: {
		width: '100%',
	},
})(
	({classes, children}) => (
		<table className={classes.table}>
			<tbody>
			{children}
			</tbody>
		</table>
	));

export const SessionInfoTableRow = withStyles(theme => ({
	row: {
		width: '100%',
	},
	col1: {
		verticalAlign: 'top',
		padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
		minWidth: 140,
		maxWidth: 400,
		flexGrow: 0,
	},
	col2: {
		padding: theme.spacing(1),
		minWidth: 200,
		flexGrow: 5,
		margin: 'auto',
	},
}))(({label, classes, children}) => (
	<tr className={classes.row}>
		<td className={classes.col1}>{label}</td>
		<td className={classes.col2}>{children}</td>
	</tr>
));

// implemented with flex box - not working in IE
//
// export const SessionInfoTable = withStyles({
// 	table: {
// 		width: '100%',
// 		display: 'flex',
// 		flexFlow: 'row wrap',
// 	},
// })(
// 	({classes, children}) => (
// 		<div className={classes.table}>
// 			{children}
// 		</div>
// 	));
//
// export const SessionInfoTableRow = withStyles(theme => ({
// 	row: {
// 		width: '100%',
// 		display: 'flex',
// 		flexFlow: 'row wrap',
// 		justifyContent: 'space-between',
// 	},
// 	col1: {
// 		verticalAlign: 'top',
// 		padding: `${theme.spacing(2)}px ${theme.spacing(1)}px`,
// 		minWidth: 140,
// 		maxWidth: 400,
// 		flexGrow: 0,
// 	},
// 	col2: {
// 		padding: theme.spacing(1),
// 		minWidth: 200,
// 		flexGrow: 5,
// 		margin: 'auto',
// 	},
// }))(({label, classes, children}) => (
// 	<div className={classes.row}>
// 		<div className={classes.col1}>{label}</div>
// 		<div className={classes.col2}>{children}</div>
// 	</div>
// ));